import { useMemo } from 'react';

import {
  maxPageSize,
  maxPageSizeOptionsLength,
  minPageSize,
} from './pagination.constants';
import { PageSizeOption } from './pagination.types';

export const usePageSizeOptions = (pageSizeOptions: PageSizeOption[]) => {
  const allowedPageSizeOptions = useMemo(() => {
    return pageSizeOptions
      .filter((opt) => {
        const pageSize = parseInt(opt.value);
        return pageSize >= minPageSize && pageSize <= maxPageSize;
      })
      .slice(0, maxPageSizeOptionsLength);
  }, [pageSizeOptions]);

  return allowedPageSizeOptions;
};
